import {z as zod} from "zod";
import type {
    Integer,
    Iso8601Date,
    Iso8601DateTime,
    Iso8601Time,
    Uuid,
} from "@vesta/common-type-definitions/typeDefinitions";

export const jsonZodValidator = zod.string().transform((str, ctx): unknown => {
    try {
        return JSON.parse(str);
    } catch (exception) {
        ctx.addIssue({
            code: "custom",
            message: `Invalid JSON: ${String(exception)}`,
        });
        return zod.NEVER;
    }
});
/**
 * @deprecated Use jsonZodValidator instead
 */
export const jsonValidator = jsonZodValidator;
/**
 * @deprecated Use jsonZodValidator instead
 */
export const zodJsonValidator = jsonZodValidator;

export const uuidZodValidator = zod.custom<Uuid>((input) => {
    const parser = zod.string().uuid();
    const parsedValueResult = parser.safeParse(input);
    return parsedValueResult.success === true;
});
/**
 * @deprecated Use uuidZodValidator instead
 */
export const zodUuidValidator = uuidZodValidator;

export const integerZodValidator = zod.custom<Integer>((input) => {
    const parser = zod.number().int();
    const parsedValueResult = parser.safeParse(input);
    return parsedValueResult.success === true;
});
export const coercedIntegerZodValidator = zod.coerce
    .number()
    .pipe(integerZodValidator);
/**
 * @deprecated Use integerZodValidator instead
 */
export const zodIntegerValidator = integerZodValidator;

export const booleanStringZodValidator = zod
    .union([zod.literal("true"), zod.literal("false")])
    .transform((value) => value === "true");

const nonEmptyStringToNumberZodValidator = zod
    .string()
    .refine((value) => value.trim().length > 0)
    .transform((value) => Number(value))
    .pipe(zod.number().refine((value) => Number.isFinite(value)));

export const stringToNumberZodValidator = nonEmptyStringToNumberZodValidator;

export const stringToIntegerZodValidator = nonEmptyStringToNumberZodValidator
    .pipe(zod.number().int())
    .transform((value) => value as Integer);

export const iso8601DateTimeZodValidator = zod.custom<Iso8601DateTime>((input) => {
    const parser = zod.iso.datetime();
    const parsedValueResult = parser.safeParse(input);
    return parsedValueResult.success === true;
});
/**
 * @deprecated Use iso8601DateTimeZodValidator instead
 */
export const zodIso8601DateTimeValidator = iso8601DateTimeZodValidator;

export const iso8601DateZodValidator = zod.custom<Iso8601Date>((input) => {
    const parser = zod.iso.date();
    const parsedValueResult = parser.safeParse(input);
    return parsedValueResult.success === true;
});
/**
 * @deprecated Use iso8601DateZodValidator instead
 */
export const zodIso8601DateValidator = iso8601DateZodValidator;

export const iso8601TimeZodValidator = zod.custom<Iso8601Time>((input) => {
    const parser = zod.iso.time();
    const parsedValueResult = parser.safeParse(input);
    return parsedValueResult.success === true;
});

export const fileZodValidator = zod.instanceof(File);

// export const formData: {
//     <T extends z.ZodRawShape>(shape: T): ZodEffects<ZodObject<T>, z.output<ZodObject<T>>, FormData | FormDataLikeInput | z.input<ZodObject<T>>>;
//     <T extends z.ZodTypeAny>(schema: T): ZodEffects<T, z.output<T>, FormData | FormDataLikeInput | z.input<T>>;
// } = (shapeOrSchema: any): any => z.preprocess(processFormData, shapeOrSchema instanceof ZodType ? shapeOrSchema : z.object(shapeOrSchema));
